import { Calendar } from "lucide-react";
import { type FC } from "react";

import { Text, Heading, Card } from "@/components/ui";

import { useWidgetConfig } from "../../../hooks/useWidgetConfig";
import { WIDGET_IDS } from "../../../store/widgetRegistry";
import { WidgetContainer } from "../base";

/**
 * TimeTracQDailyPlanWidget - Zeigt Daily Plan Summary
 *
 * NOTE: Daily Plan Daten-Loading wird in zukünftiger Version implementiert
 *
 * @returns {JSX.Element} TimeTracQ daily plan widget component
 *
 */
export const TimeTracQDailyPlanWidget: FC = () => {
  const { config } = useWidgetConfig(WIDGET_IDS.TIMETRACQ_DAILY_PLAN);

  // NOTE: Daily Plan Hook wird in zukünftiger Version implementiert
  const loading = false;
  const planItems = 0;
  const completedItems = 0;

  return (
    <WidgetContainer
      description="Today's plan summary"
      icon={<Calendar className="w-5 h-5" />}
      loading={loading}
      size={config?.size ?? "small"}
      title="Daily Plan"
      widgetId={WIDGET_IDS.TIMETRACQ_DAILY_PLAN}
    >
      <Card className="text-center" padding="sm" variant="default">
        <Text className="text-xs text-gray-400 mb-2">Plan Progress</Text>
        <Heading className="text-2xl font-bold text-white mb-1" level={4}>
          {completedItems} / {planItems}
        </Heading>
      </Card>
    </WidgetContainer>
  );
};
